import React, { Fragment } from "react";
import "../App.css";

const Pagination = ({
  totalPosts,
  postsPerPage,
  setCurrentPage,
  currentPage,
}) => {
  let pages = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pages.push(i);
  }

  return (
    <Fragment>
      <div className="paginat">
        {currentPage === 1 ? (
          <div className="mrauto">
            <button disabled className="disbtn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="dis-svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Previous
            </button>
          </div>
        ) : (
          <div className="mrauto">
            <button
              className="realbtn"
              onClick={() => {
                setCurrentPage(currentPage - 1);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="real-svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Previous
            </button>
          </div>
        )}

        {/* <div className="pagination">
          {pages.map((page, index) => {
            return (
              <>
                <button
                  key={index}
                  onClick={() => setCurrentPage(page)}
                  className={
                    page === currentPage
                      ? "font-bold text-mhblack font-luxurious bg-mhyellow px-2 rounded-md text-base mx-2"
                      : "mx-2"
                  }
                >
                  {page}
                </button>
              </>
            );
          })}
        </div> */}

        {currentPage >= pages.length ? (
          <div className="mlauto">
            <button disabled className="disbtn float-right ">
              Next{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="dis-svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        ) : (
          <div className="mlauto">
            <button
              className="realbtn"
              onClick={() => {
                setCurrentPage(currentPage + 1);
              }}
            >
              Next
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="real-svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Pagination;
